"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  EMAIL: null,
  EMAIL_ACTIVITY: null,
  TASK: null,
  MEETING: null,
  CALL: null,
  NOTE: null,
  INCOMING_EMAIL: null,
  FORWARDED_EMAIL: null,
  FEEDBACK_SUBMISSION: null,
  CONVERSATION_SESSION: null
});

exports.default = _default;
module.exports = exports.default;